import { Box, Collapse, Grid, Modal } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { FiEdit } from "react-icons/fi";
import LoadingBackdrop from "../components/general/LoadingBackdrop";
import NunitoText from "../components/general/NunitoText";
import ReusableToggle from "../components/general/ReusableToggle";
import "../css/moderateTeamBased.css";
import {
  exportMMM,
  exportMW,
  getMMMData,
  getMWData,
  getTeamBasedComputeStatus,
  getTeamsList,
} from "../functions/getData";

import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Table, Tooltip } from "antd";
import { useSnackbar } from "notistack";
import { FaCircleQuestion } from "react-icons/fa6";
import CheatingBar from "../components/CheatingBar";
import Filter from "../components/Filter";
import ReusableButton from "../components/general/ReusableButton";
import ReusableTextField from "../components/general/ReusableTextField";
import EditFinalAwardModal from "../components/modal/EditFinalAwardModal";
import MarkTeamBasedHintModal from "../components/modal/MarkTeamBasedHintModal";
import ViewAndFilterButton from "../components/ViewAndFilterButton";
import ViewOption from "../components/ViewOption";
import {
  controlFilter,
  controlView,
  makeOptions,
  makeSureIsArray,
} from "../functions/general";
import {
  computeTeamBasedCompetitionWithErrorHandling,
  MarkMMM,
  MarkMW,
  updateMMMFinalAward,
  updateMWFinalAward,
  updateTeamBasedFinalAward,
} from "../functions/postData";
import { showNotification } from "../functions/snackbar";

const ModerateTeamBasedCompetitions = () => {
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [displayMMM, setDisplayMMM] = useState(true);
  const [MMMData, setMMMData] = useState([]);
  const [MWData, setMWData] = useState([]);

  const [filtered, setFiltered] = useState([
    { label: "Award", state: "", key: "award", header: "award" },
    { label: "Division", state: "", key: "division", header: "division" },
  ]);
  const searchParams = new URLSearchParams(location.search);
  const isSimoc = searchParams.get("is_simoc") === "true";
  const handleView = () => controlView(viewing, setViewing, setFiltering);
  const handleFilter = () => controlFilter(filtering, setFiltering, setViewing);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentMW, setCurrentMW] = useState(1);
  const [totalMw, setTotalMW] = useState(0);
  const [selectedAward, setSelectedAward] = useState();
  const [selectedDivision, setSelectedDivision] = useState();
  const [isEditAward, setIsEditAward] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [currentRowFinalAward, setCurrentRowFinalAward] = useState();
  const [viewing, setViewing] = useState(false);
  const [filtering, setFiltering] = useState(false);
  const [isInstructions, setIsInstructions] = useState(false);
  const [filterOptions, setFilterOptions] = useState();
  const [MwFilterOptions, setMwFilterOptions] = useState();
  const [search, setSearch] = useState("");
  const [questionsCount, setQuestionsCount] = useState(4);
  const [computeProgress, setComputeProgress] = useState(0);
  const [computeError, setComputeError] = useState("");
  const [computeMessage, setComputeMessage] = useState("");
  const [awards, setAwards] = useState([]);
  const pollingIntervalRef = useRef(null);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    fetchData({ page: 1 });

    // Cleanup polling interval on unmount
    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }
    };
  }, []);

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys) => {
      setSelectedRowKeys(selectedKeys);
    },
  };

  const fetchData = async ({ page, limits, searchInput, award, division }) => {
    const id = searchParams.get("id");
    setLoading(true);
    const queryParams = {};
    queryParams.limits = rowsPerPage;
    if (limits !== undefined) queryParams.limits = limits;
    if (page !== undefined) queryParams.page = page;
    if (searchInput) queryParams.search = searchInput;
    if (award) queryParams.award = award;
    if (division) queryParams.division = division;

    const fullQuery = Object.keys(queryParams).length
      ? `?${new URLSearchParams(queryParams).toString()}`
      : "";
    const MMM = await (isSimoc
      ? getMMMData(id, fullQuery)
      : getTeamsList(fullQuery, id));
    let MW = null;
    if (isSimoc) {
      MW = await getMWData(id, fullQuery);
    }
    // Extract questions_count from the first team if available
    let currentQuestionsCount = 4; // default
    if (!isSimoc && MMM?.data && MMM.data.length > 0) {
      const firstTeam = MMM.data[0];
      if (firstTeam?.questions_count) {
        currentQuestionsCount = firstTeam.questions_count;
        setQuestionsCount(firstTeam.questions_count);
      }
    }
    setMwFilterOptions({
      award: MW?.awards,
      division: MW?.divisions,
    });
    setFilterOptions({
      award: MMM?.awards,
      division: MMM?.divisions,
    });
    setAwards(MMM?.awards);
    setMMMData(formatMMM(MMM?.data, currentQuestionsCount));
    const current = displayMMM ? MMM : MW;
    setTotalItems(current?.meta?.total);
    setCurrentPage(current.meta?.current_page);
    setCurrentMW(MW?.meta?.current_page);
    setTotalMW(MW?.meta?.total);
    setMWData(formatMW(MW?.data));

    setLoading(false);
  };

  const formatMMM = (data, qCount = 4) => {
    let formattedData = [];
    data?.map((el) => {
      let formattedObj = {};
      let nestedRows = [];
      formattedObj.totalScore = isSimoc
        ? `${el?.score || "-"} / ${el?.max_score || "-"}`
        : `${el?.score || "-"}`;
      formattedObj.system_award = el?.system_award || "-";
      formattedObj.final_award = (
        <div className="final-awrad-wrapper">
          <span className="final-award-title">{el?.final_award || "-"}</span>{" "}
          <span
            onClick={() => {
              setCurrentRowFinalAward(el);
              setIsEditAward(true);
            }}
          >
            <FiEdit />
          </span>
        </div>
      );
      formattedObj.score_percentage = `${el?.score_percentage || "-"}%`;
      formattedObj.team_number = el?.team_number;
      formattedObj.devision = el?.division || "-";
      formattedObj.teamNumber = (
        <Tooltip
          title={
            <div className="tooltip-wrapper">
              <Grid
                display={"flex"}
                width={"100%"}
                justifyContent={"space-between"}
                className="tooltip-row"
              >
                <h4 className="tooltip-header">Index Number</h4>
                <h4 className="tooltip-header">Participant Name</h4>
              </Grid>
              {el?.participants.map((el) => {
                return (
                  <Grid
                    marginBottom={1}
                    display={"flex"}
                    className="tooltip-row"
                    justifyContent={"space-between"}
                    width={"98%"}
                  >
                    <span>{el?.index_no}</span>
                    <span>{el?.name}</span>
                  </Grid>
                );
              })}
            </div>
          }
        >
          {" "}
          {el?.team_number}
        </Tooltip>
      );
      el?.answers?.map((answer) => {
        console.log(answer);
        let formattedNestedObj = {};
        const answers = makeSureIsArray(answer.answer_row);
        // Dynamically create q1, q2, ..., qn based on questions_count
        for (let i = 1; i <= qCount; i++) {
          console.log(answers?.[`question_${i}`]);
          formattedNestedObj[`q${i}`] =
            answer?.answer_row?.[`question_${i}`] ||
            answer?.answer_row?.[`q${i}`] ||
            "-";
        }
        formattedNestedObj.set = answer?.set || "-";
        formattedNestedObj.score = answer?.score || "-";
        nestedRows?.push(formattedNestedObj);
      });
      formattedObj.nestedData = nestedRows;
      formattedData.push(formattedObj);
    });
    console.log(formattedData);
    return formattedData;
  };

  const formatMW = (data) => {
    let formattedData = [];
    data?.map((el) => {
      let formattedObj = {};
      let nestedRows = [];
      formattedObj.devision = el?.division;
      formattedObj.team_number = el?.team_number;
      formattedObj.teamNumber = (
        <Tooltip
          title={
            <div className="tooltip-wrapper">
              <Grid
                display={"flex"}
                width={"100%"}
                justifyContent={"space-between"}
                className="tooltip-row"
              >
                <h4 className="tooltip-header">Index Number</h4>
                <h4 className="tooltip-header">Participant Name</h4>
              </Grid>
              {el?.participants.map((el) => {
                return (
                  <Grid
                    marginBottom={1}
                    display={"flex"}
                    className="tooltip-row"
                    justifyContent={"space-between"}
                    width={"98%"}
                  >
                    <span>{el?.index_no}</span>
                    <span>{el?.name}</span>
                  </Grid>
                );
              })}
            </div>
          }
        >
          {" "}
          {el?.team_number}
        </Tooltip>
      );
      formattedObj.totalScore = `${el?.score || "-"} / ${el?.max_score || "-"}`;
      formattedObj.score_percentage = `${el?.score_percentage || "-"}%`;
      formattedObj.system_award = el?.system_award || "-";
      formattedObj.final_award = (
        <div className="final-awrad-wrapper">
          <span className="final-award-title">{el?.final_award || "-"}</span>{" "}
          <span
            onClick={() => {
              setCurrentRowFinalAward(el);
              setIsEditAward(true);
            }}
          >
            <FiEdit />
          </span>
        </div>
      );
      console.log(el);
      const { questions_count } = el || 0;
      el?.answers?.map((el) => {
        let formattedNestedObj = {};
        formattedNestedObj.indexNumber = el?.participant_index || "-";
        formattedNestedObj.studentName = el?.participant?.name || "-";
        formattedNestedObj.grade = el?.participant?.grade || "-";
        formattedNestedObj.r1g1 = el?.answer_row?.R1G1?.answer || "-";
        formattedNestedObj.r1g2 = el?.answer_row?.R1G2?.answer || "-";
        formattedNestedObj.r1g3 = el?.answer_row?.R1G3?.answer || "-";
        formattedNestedObj.r2g1 = el?.answer_row?.R2G1?.answer || "-";
        formattedNestedObj.r2g2 = el?.answer_row?.R2G2?.answer || "-";
        formattedNestedObj.r2g3 = el?.answer_row?.R2G3?.answer || "-";
        formattedNestedObj.score = el?.score || "-";
        nestedRows?.push(formattedNestedObj);
      });
      formattedObj.nestedData = nestedRows;
      formattedData.push(formattedObj);
    });
    return formattedData;
  };

  const MMMTableColumns = [
    { title: "Division", dataIndex: "devision", key: "devision" },
    { title: "Team Number", dataIndex: "teamNumber", key: "teamNumber" },
    { title: "Score", dataIndex: "totalScore", key: "totalScore" },
    isSimoc
      ? {
          title: "Score Percentage",
          dataIndex: "score_percentage",
          key: "score_percentage",
        }
      : null,
    { title: "System Award", dataIndex: "system_award", key: "award" },
    { title: "Final Award", dataIndex: "final_award", key: "award" },
  ].filter(Boolean);

  const generateQuestionColumns = (count) => {
    const columns = [];
    for (let i = 1; i <= count; i++) {
      columns.push({
        title: `Q${i}`,
        dataIndex: `q${i}`,
        key: `q${i}`,
        render: (data) => {
          console.log(data);
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <span>{data?.answer || data || "-"}</span>
              {isSimoc &&
                (data?.is_correct ? (
                  <span>
                    <CheckOutlined style={{ color: "green", fontSize: 20 }} />
                  </span>
                ) : (
                  <CloseOutlined style={{ color: "red", fontSize: 20 }} />
                ))}
            </div>
          );
        },
      });
    }
    return columns;
  };

  const MMMNestedColumns = useMemo(
    () =>
      [
        isSimoc ? { title: "Set", dataIndex: "set", key: "set" } : null,
        ...(isSimoc
          ? [
              {
                title: "Q1",
                dataIndex: "q1",
                key: "q1",
                render: (data) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <span>{data?.answer}</span>
                      {data?.is_correct ? (
                        <span>
                          <CheckOutlined
                            style={{ color: "green", fontSize: 20 }}
                          />
                        </span>
                      ) : (
                        <CloseOutlined style={{ color: "red", fontSize: 20 }} />
                      )}
                    </div>
                  );
                },
              },
              {
                title: "Q2",
                dataIndex: "q2",
                key: "q2",
                render: (data) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <span>{data?.answer}</span>
                      {data?.is_correct ? (
                        <span>
                          <CheckOutlined
                            style={{ color: "green", fontSize: 20 }}
                          />
                        </span>
                      ) : (
                        <CloseOutlined style={{ color: "red", fontSize: 20 }} />
                      )}
                    </div>
                  );
                },
              },
              {
                title: "Q3",
                dataIndex: "q3",
                key: "q3",
                render: (data) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <span>{data?.answer}</span>
                      {data?.is_correct ? (
                        <span>
                          <CheckOutlined
                            style={{ color: "green", fontSize: 20 }}
                          />
                        </span>
                      ) : (
                        <CloseOutlined style={{ color: "red", fontSize: 20 }} />
                      )}
                    </div>
                  );
                },
              },
              {
                title: "Q4",
                dataIndex: "q4",
                key: "q4",
                render: (data) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <span>{data?.answer}</span>
                      {data?.is_correct ? (
                        <span>
                          <CheckOutlined
                            style={{ color: "green", fontSize: 20 }}
                          />
                        </span>
                      ) : (
                        <CloseOutlined style={{ color: "red", fontSize: 20 }} />
                      )}
                    </div>
                  );
                },
              },
            ]
          : generateQuestionColumns(questionsCount)),
        isSimoc
          ? {
              title: "Score",
              dataIndex: "score",
              key: "score",
            }
          : null,
      ].filter(Boolean),
    [isSimoc, questionsCount]
  );

  const MWTableColumns = [
    { title: "Devision", dataIndex: "devision", key: "devision" },
    { title: "Team Number", dataIndex: "teamNumber", key: "teamNumber" },
    { title: "Score", dataIndex: "totalScore", key: "totalScore" },
    {
      title: "Score Percentage",
      dataIndex: "score_percentage",
      key: "score_percentage",
    },
    { title: "System Award", dataIndex: "system_award", key: "award" },
    { title: "Final Award", dataIndex: "final_award", key: "award" },
  ];

  const MWNestedColumns = [
    { title: "Index Number", dataIndex: "indexNumber", key: "indexNumber" },
    { title: "Student Name", dataIndex: "studentName", key: "studentName" },
    { title: "Grade", dataIndex: "grade", key: "grade" },
    { title: "R1G1", dataIndex: "r1g1", key: "r1g1" },
    { title: "R1G2", dataIndex: "r1g2", key: "r1g2" },
    { title: "R1G3", dataIndex: "r1g3", key: "r1g3" },
    { title: "R2G1", dataIndex: "r2g1", key: "r2g1" },
    { title: "R2G2", dataIndex: "r2g2", key: "r2g2" },
    { title: "R2G3", dataIndex: "r2g3", key: "r2g3" },
    { title: "Score", dataIndex: "score", key: "score" },
  ];
  const expandedRowRender = (record) => (
    <Table
      columns={displayMMM ? MMMNestedColumns : MWNestedColumns}
      dataSource={record?.nestedData}
      pagination={false}
      rowKey={(row, index) => index}
    />
  );

  const pollComputeStatus = async (competitionId) => {
    try {
      const response = await getTeamBasedComputeStatus(competitionId);

      if (!response || !response.status) {
        console.warn("Unexpected response structure:", response);
        // Continue polling if response structure is unexpected
        return { done: false, error: null };
      }

      if (response.status === "in_progress") {
        // Update progress
        const progress = parseInt(response.progress) || 0;
        setComputeProgress(progress);
        setComputeMessage("Computing in progress...");
        setComputeError("");
        // Continue polling
        return { done: false, error: null };
      } else if (response.status === "completed") {
        // Stop polling
        if (pollingIntervalRef.current) {
          clearInterval(pollingIntervalRef.current);
          pollingIntervalRef.current = null;
        }
        setComputeProgress(100);
        setComputeMessage("Computing completed!");
        setComputeError("");
        return { done: true, error: null };
      } else if (response.status === "error") {
        // Stop polling on error
        if (pollingIntervalRef.current) {
          clearInterval(pollingIntervalRef.current);
          pollingIntervalRef.current = null;
        }
        const errorMessage =
          response.message || "Computing failed. Please contact support.";
        setComputeError(errorMessage);
        setComputeMessage("");
        return { done: true, error: errorMessage };
      } else {
        // Unknown status - continue polling
        console.warn("Unknown status:", response.status);
        return { done: false, error: null };
      }
    } catch (error) {
      console.error("Error polling compute status:", error);
      // Continue polling on network errors
      return { done: false, error: null };
    }
  };

  const handleComputeData = async () => {
    const id = searchParams.get("id");
    setLoading(true);
    setComputeProgress(0);
    setComputeError("");
    setComputeMessage("");

    try {
      if (displayMMM) {
        if (isSimoc) {
          await MarkMMM(id);
          await new Promise((resolve) => setTimeout(resolve, 5000));
          showNotification(
            "success",
            `result for MMM computed successfully`,
            enqueueSnackbar,
            closeSnackbar
          );
          await fetchData({ page: 1 });
          setLoading(false);
        } else {
          // Non-SIMOC: Start compute and poll status
          const competitionId = searchParams.get("id");
          const res = await computeTeamBasedCompetitionWithErrorHandling(
            competitionId
          );
          console.log(res);
          // Remove loading backdrop and start polling
          setLoading(false);
          setComputeMessage("Computing started...");
          const handlePollResult = async (result) => {
            // Add null check to prevent errors
            if (!result) {
              console.warn("Poll result is undefined, continuing to poll");
              return false;
            }

            if (result.done) {
              if (pollingIntervalRef.current) {
                clearInterval(pollingIntervalRef.current);
                pollingIntervalRef.current = null;
              }

              if (result.error) {
                showNotification(
                  "error",
                  result.error,
                  enqueueSnackbar,
                  closeSnackbar
                );
                setLoading(false);
              } else {
                // Success - fetch data and show notification
                showNotification(
                  "success",
                  "Result computed successfully",
                  enqueueSnackbar,
                  closeSnackbar
                );
                await fetchData({ page: 1 });
                setLoading(false);
                // Reset progress after a delay
                setTimeout(() => {
                  setComputeProgress(0);
                  setComputeMessage("");
                }, 2000);
              }
              return true; // Signal to stop polling
            }
            return false; // Continue polling
          };

          // Do initial poll immediately
          const initialResult = await pollComputeStatus(competitionId);
          const shouldStop = await handlePollResult(initialResult);

          // Only start interval if not already done
          if (!shouldStop) {
            const pollInterval = setInterval(async () => {
              const result = await pollComputeStatus(competitionId);
              await handlePollResult(result);
            }, 2000); // Poll every 2 seconds

            pollingIntervalRef.current = pollInterval;
          }
        }
      } else {
        // MW case
        await MarkMW(id);
        await new Promise((resolve) => setTimeout(resolve, 5000));
        showNotification(
          "success",
          `result for MW computed successfully`,
          enqueueSnackbar,
          closeSnackbar
        );
        await fetchData({ page: 1 });
        setLoading(false);
      }
    } catch (error) {
      console.error("Error in handleComputeData:", error);
      showNotification(
        "error",
        "An error occurred during computation",
        enqueueSnackbar,
        closeSnackbar
      );
      setLoading(false);
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }
    }
  };

  const handleExportData = async () => {
    setLoading(true);
    const id = searchParams.get("id");
    if (displayMMM) {
      await exportMMM(id);
    } else {
      await exportMW(id);
    }
    setLoading(false);
  };

  const updateFinalAward = async (payload) => {
    setLoading(true);
    const id = searchParams.get("id");
    if (displayMMM) {
      await (isSimoc
        ? updateMMMFinalAward(id, payload)
        : updateTeamBasedFinalAward(id, payload));
    } else {
      await updateMWFinalAward(id, payload);
    }
    await fetchData({ page: 1, searchInput: search, limits: rowsPerPage });
    setCurrentRowFinalAward();
    setSelectedRowKeys([]);
    setIsEditAward(false);
    setLoading(false);
  };

  const onChangeRowsPerPage = (pageNo) => {
    setRowsPerPage(pageNo);
    fetchData({ page: 1, limits: pageNo, searchInput: search });
  };

  const onChangeFiltered = (newfilter) => {
    setFiltered(newfilter);
    const award = newfilter[0]?.state !== "" ? newfilter[0]?.state : undefined;
    const division =
      newfilter[1]?.state !== "" ? newfilter[1]?.state : undefined;
    setSelectedAward(award);
    setSelectedDivision(division);
    fetchData({
      award: award,
      division: division,
      searchInput: search,
    });
  };

  const onChangeSearch = (search) => {
    setSearch(search);
    fetchData({
      page: 1,
      searchInput: search,
      limits: rowsPerPage,
      award: selectedAward,
      division: selectedDivision,
    });
  };
  return (
    <Box className="wrapperBox moderate-team-based-wrapper">
      <LoadingBackdrop loading={loading} />
      <Collapse in={viewing}>
        <ViewOption
          rowsPerPage={rowsPerPage}
          onChangeRowsPerPage={onChangeRowsPerPage}
        />
      </Collapse>
      <Collapse in={filtering}>
        {filterOptions && (
          <Filter
            type="collapse"
            filterOptions={filtered.map((f) =>
              makeOptions(
                displayMMM ? filterOptions : MwFilterOptions,
                f.header
              )
            )}
            filtered={filtered}
            onChangeFiltered={onChangeFiltered}
          />
        )}
      </Collapse>
      <Grid width={"100%"} padding={"50px"}>
        <Grid
          className="first-row-container"
          justifyContent={"space-between"}
          marginBottom={5}
        >
          <NunitoText
            value="Moderate Team based Competition"
            fontSize={40}
            fontWeight={700}
            italic
            color="#144A94"
          />
          <Grid
            display={"flex"}
            alignItems={"center"}
            justifyContent={"flex-start"}
            gap={"5px"}
          >
            <div className="viewAndFilterBtnDiv">
              <ViewAndFilterButton
                text="View Options"
                state={viewing}
                fontSize={14}
                height={42}
                onClick={handleView}
                marginRight={10}
              />
              <ViewAndFilterButton
                text="Filter"
                state={filtering}
                fontSize={14}
                height={42}
                onClick={handleFilter}
              />
            </div>
            {isSimoc && (
              <ReusableToggle
                type="text"
                width={250}
                falseValue="MW"
                trueValue="MMM"
                state={displayMMM}
                setState={setDisplayMMM}
              />
            )}
          </Grid>
        </Grid>
        {isSimoc && (
          <Grid
            display={"flex"}
            width={"100%"}
            justifyContent={"flex-end"}
            marginBottom={5}
          >
            <FaCircleQuestion
              style={{
                color: "#5E75C3",
                fontSize: "45px",
                textAlign: "center",
                marginRight: "30px",
                cursor: "pointer",
              }}
              onClick={() => {
                setIsInstructions(true);
              }}
            />
          </Grid>
        )}
        <Grid display={"flex"}>
          <ReusableTextField
            type="search"
            width={500}
            height={60}
            bgColor="#F2F2F2"
            placeholder="Search using Team Number"
            state={search}
            setState={(e) => {
              onChangeSearch(e);
              console.log(e);
            }}
            onBlur
          />
          <Grid
            alignItems={"flex-end"}
            justifyContent={"flex-end"}
            width={"100%"}
            display={"flex"}
          >
            <ReusableButton
              text={"Edit Final Award"}
              fontSize={15}
              height={47}
              marginBottom={30}
              disabledButton={!!!selectedRowKeys.length}
              bgColor={!!!selectedRowKeys?.length ? "#707070" : "#5E75C3"}
              onClick={() => {
                setIsEditAward(true);
              }}
              iconType="edit"
            />
            <ReusableButton
              text={
                isSimoc
                  ? `Compute Marking for ${displayMMM ? "MMM" : "MW"}`
                  : `Compute Marking`
              }
              fontSize={15}
              bgColor={"#5E75C3"}
              height={47}
              marginBottom={30}
              marginLeft={8}
              onClick={() => {
                handleComputeData();
              }}
              iconType="compute"
            />
            <ReusableButton
              text={
                isSimoc
                  ? `Export Data for ${displayMMM ? "MMM" : "MW"}`
                  : `Export Data`
              }
              fontSize={15}
              bgColor={"#5E75C3"}
              height={47}
              marginLeft={8}
              marginBottom={30}
              onClick={() => {
                handleExportData();
              }}
              iconType="download"
            />
          </Grid>
        </Grid>
        {!isSimoc &&
        displayMMM &&
        (computeProgress > 0 || computeError || computeMessage) ? (
          <Grid marginBottom={3} marginTop={2}>
            <CheatingBar
              percentage={computeProgress}
              setPercentage={setComputeProgress}
              err={computeError}
              msg={
                computeMessage ||
                (computeProgress > 0 ? "Computing in progress..." : "")
              }
            />
          </Grid>
        ) : (
          <Table
            rowKey={(row, index) => row}
            rowSelection={rowSelection}
            columns={displayMMM ? MMMTableColumns : MWTableColumns}
            dataSource={displayMMM ? MMMData : MWData}
            expandable={{ expandedRowRender, defaultExpandedRowKeys: ["0"] }}
            pagination={{
              showSizeChanger: false,
              current: displayMMM ? currentPage : currentMW,
              pageSize: pageSize,
              total: displayMMM ? totalItems : totalMw,
              onChange: (page, pageSize) => {
                setCurrentPage(page);
                setPageSize(pageSize);
                fetchData({
                  page: page,
                  searchInput: search,
                  award: selectedAward,
                  division: selectedDivision,
                });
              },
            }}
          />
        )}
      </Grid>
      <Modal open={isEditAward} onClose={() => setIsEditAward(false)}>
        <EditFinalAwardModal
          isSimoc={isSimoc}
          setcurrentFinalAward={setCurrentRowFinalAward}
          currentRowFinalAward={currentRowFinalAward}
          updateFinalAward={updateFinalAward}
          setEditModal={setIsEditAward}
          selectedRowKeys={selectedRowKeys}
          awards={awards}
        />
      </Modal>
      <Modal open={isInstructions} onClose={() => setIsInstructions(false)}>
        <MarkTeamBasedHintModal displayMMMcontent={displayMMM} />
      </Modal>
    </Box>
  );
};

export default ModerateTeamBasedCompetitions;
